// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"7086e8a4","845":"ecc04588"}[chunkId] + ".chunk.js";
};